import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'relements/build/esm/input/dropdown';

import styles from './AttachmentEntityConfig.scss';

const attachmentOptions = [
  { title: 'Image', id: 'image' },
  { title: 'Document (pdf, docx, xls, csv)', id: 'document' },
  { title: 'Video', id: 'video' },
];

export default class AttachmentEntityConfig extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <Dropdown
          disabled={this.props.disabled}
          placeholder="Type of Attachment"
          value={attachmentOptions.filter(
            option => option.id === this.props.metaData.attachmentType
          )}
          onChange={this._updateAttachmentType}
          options={attachmentOptions}
          optionKey="title"
        />
      </div>
    );
  }

  _updateAttachmentType = value => {
    const { metaData } = this.props;
    metaData.attachmentType = value.id;
    this.props.onChange(metaData);
  };
}

AttachmentEntityConfig.propTypes = {
  metaData: PropTypes.shape({
    attachmentType: PropTypes.string,
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
